import { apiClient } from './client';
import { parseGameResources } from './game-resource-contract';

export const gameResourcesApi = {
  async get() {
    return parseGameResources(await apiClient.users.getProgress());
  },
};
